import { Redirect, Route } from "react-router";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, ...rest }) => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const token = localStorage.getItem("token");
  const authenticated = isAuthenticated && token ? true : false;
  return (
     <Route {...rest} render={({ location }) => children} />
    // <Route
    //   {...rest}
    //   render={({ location }) =>
    //     authenticated ? (
    //       children
    //     ) : (
    //       <Redirect
    //         to={{
    //           pathname: "/login",
    //           state: { from: location }
    //         }}
    //       />
    //     )
    //   }
    // />
  );
};

export default ProtectedRoute;
